export enum CronInterval {
  'X_HIGH',
  'HIGH',
  'MEDIUM',
  'LOW'
}
